@if (isLink()) {
  <!-- Anchor mode: render <a> styled as a button (routerLink or external href). -->
  @if (isRouterLink()) {
    @switch (variant()) {
      @case ('outlined') {
        <a
          mat-stroked-button
          class="app-btn app-btn--outlined"
          [class.app-btn--primary]="isPrimary()"
          [color]="matColor()"
          [routerLink]="routerLink()"
          [target]="target()"
          [attr.aria-label]="ariaLabel()"
        >
          <ng-container [ngTemplateOutlet]="content" />
        </a>
      }
      @case ('text') {
        <a
          mat-button
          class="app-btn app-btn--text"
          [class.app-btn--primary]="isPrimary()"
          [color]="matColor()"
          [routerLink]="routerLink()"
          [target]="target()"
          [attr.aria-label]="ariaLabel()"
        >
          <ng-container [ngTemplateOutlet]="content" />
        </a>
      }
      @case ('elevated') {
        <a
          mat-raised-button
          class="app-btn app-btn--elevated"
          [class.app-btn--primary]="isPrimary()"
          [color]="matColor()"
          [routerLink]="routerLink()"
          [target]="target()"
          [attr.aria-label]="ariaLabel()"
        >
          <ng-container [ngTemplateOutlet]="content" />
        </a>
      }
      @default {
        <a
          mat-flat-button
          class="app-btn app-btn--filled"
          [class.app-btn--primary]="isPrimary()"
          [color]="matColor()"
          [routerLink]="routerLink()"
          [target]="target()"
          [attr.aria-label]="ariaLabel()"
        >
          <ng-container [ngTemplateOutlet]="content" />
        </a>
      }
    }
  } @else {
    @switch (variant()) {
      @case ('outlined') {
        <a
          mat-stroked-button
          class="app-btn app-btn--outlined"
          [class.app-btn--primary]="isPrimary()"
          [color]="matColor()"
          [attr.href]="href()"
          [attr.target]="target()"
          [attr.aria-label]="ariaLabel()"
        >
          <ng-container [ngTemplateOutlet]="content" />
        </a>
      }
      @case ('text') {
        <a
          mat-button
          class="app-btn app-btn--text"
          [class.app-btn--primary]="isPrimary()"
          [color]="matColor()"
          [attr.href]="href()"
          [attr.target]="target()"
          [attr.aria-label]="ariaLabel()"
        >
          <ng-container [ngTemplateOutlet]="content" />
        </a>
      }
      @case ('elevated') {
        <a
          mat-raised-button
          class="app-btn app-btn--elevated"
          [class.app-btn--primary]="isPrimary()"
          [color]="matColor()"
          [attr.href]="href()"
          [attr.target]="target()"
          [attr.aria-label]="ariaLabel()"
        >
          <ng-container [ngTemplateOutlet]="content" />
        </a>
      }
      @default {
        <a
          mat-flat-button
          class="app-btn app-btn--filled"
          [class.app-btn--primary]="isPrimary()"
          [color]="matColor()"
          [attr.href]="href()"
          [attr.target]="target()"
          [attr.aria-label]="ariaLabel()"
        >
          <ng-container [ngTemplateOutlet]="content" />
        </a>
      }
    }
  }
} @else {
  @switch (variant()) {
    @case ('outlined') {
      <button
        mat-stroked-button
        class="app-btn app-btn--outlined"
        [class.app-btn--primary]="isPrimary()"
        [color]="matColor()"
        [type]="type()"
        [disabled]="isDisabled()"
        [attr.aria-label]="ariaLabel()"
      >
        <ng-container [ngTemplateOutlet]="content" />
      </button>
    }
    @case ('text') {
      <button
        mat-button
        class="app-btn app-btn--text"
        [class.app-btn--primary]="isPrimary()"
        [color]="matColor()"
        [type]="type()"
        [disabled]="isDisabled()"
        [attr.aria-label]="ariaLabel()"
      >
        <ng-container [ngTemplateOutlet]="content" />
      </button>
    }
    @case ('elevated') {
      <button
        mat-raised-button
        class="app-btn app-btn--elevated"
        [class.app-btn--primary]="isPrimary()"
        [color]="matColor()"
        [type]="type()"
        [disabled]="isDisabled()"
        [attr.aria-label]="ariaLabel()"
      >
        <ng-container [ngTemplateOutlet]="content" />
      </button>
    }
    @default {
      <button
        mat-flat-button
        class="app-btn app-btn--filled"
        [class.app-btn--primary]="isPrimary()"
        [color]="matColor()"
        [type]="type()"
        [disabled]="isDisabled()"
        [attr.aria-label]="ariaLabel()"
      >
        <ng-container [ngTemplateOutlet]="content" />
      </button>
    }
  }
}

<ng-template #content>
  @if (loading()) {
    <mat-progress-spinner class="app-button__spinner" diameter="18" mode="indeterminate" />
  }
  <ng-content />
</ng-template>
